import React from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import { getAuthConfig } from '../../../data/auth/authSelectors'
import { useConversationsData } from '../../messages/data/hooks/useConversationsData'

export const ClientsContainer = () => {
  const config = useSelector(getAuthConfig)
  useConversationsData(undefined, { refetchOnMountOrArgChange: true, skip: config?.hideMessagesNav })

  return <Outlet />
}

export default ClientsContainer
